import React from 'react';
import {
  FormControl, FormLabel, TextField, withStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import PF2MSearchSelectOutlined from '../PF2MSearchSelectOutlined';
import styles from './styles';

const PF2MEquipmentPoolFilter = ({
  filters,
  classes,
  customStyles,
}) => (
  <div
    className={classes.wrapperForm}
    style={customStyles?.wrapperForm}
  >
    {filters.map(filter => (
      <FormControl key={`${filter.type}-${filter.label}`}>
        <FormLabel className={classes.formLabel}>{filter.label}</FormLabel>
        {filter.type === 'multiSelect' && (
          <PF2MSearchSelectOutlined
            value={filter.value}
            placeholder={filter.placeholder}
            multiple
            hideSelectedOptions={false}
            onChange={filter.onChange}
            className={classes.field}
            disabled={filter.disabled}
            maxMenuHeight={140}
          >
            {filter.options}
          </PF2MSearchSelectOutlined>
        )}
        {filter.type === 'textField' && (
          <TextField
            value={filter.value}
            placeholder={filter.placeholder}
            onChange={filter.onChange}
            className={classes.field}
            size={filter.size || 'small'}
            disabled={filter.disabled}
            variant="outlined"
            InputProps={{
              style: {
                fontSize: 14,
                fontFamily: 'Roboto',
                fontWeight: 400,
                lineHeight: '1.5px',
              },
            }}
          />
        )}
      </FormControl>
    ))}
  </div>
);

PF2MEquipmentPoolFilter.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      options: PropTypes.array,
      type: PropTypes.oneOf(['multiSelect', 'textField']),
      onChange: PropTypes.func,
      disabled: PropTypes.bool,
      size: PropTypes.string,
    }),
  ),
  classes: PropTypes.object.isRequired,
  customStyles: PropTypes.object,
};

PF2MEquipmentPoolFilter.defaultProps = {
  customStyles: {},
  filters: [],
};

export default withStyles(styles)(PF2MEquipmentPoolFilter);
